import React from 'react';
import NotificationsList from '../components/notifications/NotificationsList';

const Notifications: React.FC = () => {
  return (
    <div className="max-w-3xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">Notificaciones</h1>
      </div>

      <NotificationsList />
    </div>
  );
};

export default Notifications;
